import type { NskResponse } from "~/models/Api";
import type { DealConstructionScheduleEdit } from "~/models/DealConstructionSchedule";
import { generatePath } from "~/utils/generatePath";
import { postRequest } from "../api_handler";

export const create = async (
	dealId: number,
	schedules: DealConstructionScheduleEdit[]
): Promise<NskResponse> =>
	postRequest(
		generatePath("/vendors/deals/:deal_id/deal_construction_schedules", {
			deal_id: dealId
		}),
		{ dealConstructionSchedules: schedules }
	);
